import cloneDeep from 'lodash.clonedeep';
import {action, computed, observable} from 'mobx';
import Varidation from 'js/utils/validation';


const initialState = {
  result: {
    count: {
      yes: 0,
      no: 0,
    },
    score: {
      yes: 0,
      no: 0,
    },
    phase: 0, // db.phase.id
    advice: 0, // db.category.id
    categorys: [],
  },
};

/**
 * Aggregate Store
 */
export default class AggregateStore {
  @observable results = cloneDeep(initialState.result);
  @observable error = false;

  /**
   * constructor
   */
  constructor() {
    this.categorys = [];
    this.questions = [];
    this.phase = [];
  }

  /**
   * init
   * @param {param} param
   */
  init(param) {
    this.categorys = param.categorys;
    this.questions = param.questions;
    this.phase = param.phase;
  }

  /**
   * check answer
   * @return {boolean}
   */
  check() {
    let result = false;
    const check = this.questions.some((item) => {
      return !Varidation.required(item.checked);
    });
    if (!check) {
      result = true;
    }

    return result;
  }

  /**
   * start aggregate
   */
  @action start() {
    const total = cloneDeep(initialState.result);

    // yes - no 集計
    this.countYesNo(total);

    // スコア計算
    this.calculateScore(total);

    // 市場創造フェーズ
    this.setPhase(total);

    // 助言対象
    this.setCategoryIdOfAdviceTarget(total);

    this.results = total;
  }

  /**
   * count yes - no
   * @param {object} total
   */
  countYesNo(total) {
    const categorys = [];

    // db.categorys.id に一致するデータが対象
    this.categorys.forEach((category) => {
      const save = {
        id: category.id,
        name: category.name,
        weight: category.weight,
        yes: 0,
        no: 0,
        score: 0,
      };

      // 同一カテゴリの回答を集計
      this.questions.forEach((item) => {
        if (category.id == item.categoryId) {
          switch (item.checked) {
          case 'yes':
            save.yes++;
            break;
          case 'no':
            save.no++;
            break;
          }
        }
      });

      categorys.push(save);
    });

    // 合計
    categorys.forEach((category) => {
      total.count.yes += category.yes;
      total.count.no += category.no;
    });

    total.categorys = categorys;
  }

  /**
   * calculate score
   * @param {object} total
   */
  calculateScore(total) {
    // カテゴリ ポイント計算
    total.categorys.forEach((category) => {
      category.score = Math.round((category.yes / total.count.yes) * 100);
    });

    // 総合ポイント計算
    total.score.yes = Math.round((total.count.yes / 40) * 100);
    total.score.no = Math.round((total.count.no / 40) * 100);
  }

  /**
   * set db.phase.id
   * @param {object} total
   */
  setPhase(total) {
    for (let i = 0, l = this.phase.length; i < l; i++) {
      if (
        this.phase[i].range < total.count.yes ||
        (0 == total.count.yes && 0 == this.phase[i].range)
      ) {
        total.phase = this.phase[i].id;
        break;
      }
    }
  }

  /**
   * set db.categorys.id of advice target
   * @param {object} total
   */
  setCategoryIdOfAdviceTarget(total) {
    // スコアがもっとも低いcategory.idをセット
    let tmp = null;
    total.categorys.forEach((category, index) => {
      if (0 == index) {
        tmp = category;
        return;
      }

      // スコアが同じ場合、db.categorys.weight が大きい方をセット
      if (
        (tmp.score == category.score && tmp.weight < category.weight) ||
        (tmp.score > category.score)
      ) {
        tmp = category;
      }
    });

    total.advice = tmp.id;
  }

  /**
   * get chart scores
   * @return {array}
   */
  @computed get scores() {
    const scores = this.results.categorys;
    return scores;
  }

  /**
   * get advice type
   * @return {number}
   */
  @computed get adviceType() {
    const advice = this.results.advice;
    return advice;
  }

  /**
   * get phase
   * @return {number}
   */
  @computed get phaseId() {
    const phase = this.results.phase;
    return phase;
  }

  /**
   * get count yes
   * @return {number}
   */
  @computed get countYes() {
    const yes = this.results.count.yes;
    return yes;
  }
}



// WEBPACK FOOTER //
// ./src/js/stores/aggregate/index.js